import React from 'react';

/**
 * TextAreaElement - Independent multi-line text input component
 * Fully self-contained with no external layout dependencies
 */
const TextAreaElement = ({ element, mode = 'form' }) => {
  const { content } = element;
  const {
    label = 'Text Area',
    name = '',
    placeholder = '',
    required = false,
    rows = 4,
    helpText = ''
  } = content || {};

  // Generate field name from label if not provided
  const fieldName = name || label.toLowerCase().replace(/[^a-z0-9]+/g, '_');

  return (
    <div className="form-field" style={{ width: '100%', boxSizing: 'border-box' }}>
      {label && (
        <label className="form-label" htmlFor={fieldName}>
          {label}
          {required && <span className="form-required"> *</span>}
        </label>
      )}
      <textarea
        id={fieldName}
        name={fieldName}
        className="form-textarea"
        placeholder={placeholder}
        rows={rows}
        required={required}
        aria-required={required}
        aria-describedby={helpText ? `${fieldName}-help` : undefined}
      />
      {helpText && (
        <p
          id={`${fieldName}-help`}
          className="form-help-text"
          style={{ fontSize: '0.875rem', color: 'var(--color-text-secondary)', marginTop: '0.25rem' }}
        >
          {helpText}
        </p>
      )}
    </div>
  );
};

export default TextAreaElement;
